/**
 * This is an implementation of the "Exponential Moving Average" algorithm.
 * https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 */
export class MovingAverage {
    constructor(weightingFactorBase) {
        /**
         * The current estimated value of the exponential moving average.
         */
        this._estimate = 0;
        /**
         * The total number of sampled bytes.
         */
        this._totalWeight = 0;
        if (weightingFactorBase < 0) {
            throw new TypeError('Halflife must be set to a positive value.');
        }
        this._weightingDecrease = Math.exp(Math.log(0.5) / weightingFactorBase);
    }
    /**
     * Function for adding a sample to the window.
     *
     * @param time - The amount of time it took to fetch the bytes.
     * @param bytes - The number of bytes fetched.
     */
    sample(time, bytes) {
        const a = Math.pow(this._weightingDecrease, time / 1000);
        const estimate = bytes * (1 - a) + a * this._estimate;
        if (!isNaN(estimate)) {
            this._estimate = estimate;
            this._totalWeight += bytes;
        }
    }
    /**
     * Returns the current estimated value of the exponential moving average.
     *
     * @return The current moving average.
     */
    getEstimate() {
        return (this._estimate / 1 - Math.pow(this._weightingDecrease, this._totalWeight));
    }
}
//# sourceMappingURL=moving_average.js.map